<template>
  <div class="modal" v-bind:class="{ 'is-active': show }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title"></p>
        <div class="buttons has-addons is-right">
          <button class="delete is-right" aria-label="close" @click="closeModal"></button>
        </div>
      </header>
      <section class="modal-card-body">
        <h1 class="title has-text-centered">Instrucciones para carga empleados</h1>
        <br />
        <h2 class="subtitle">
          <p>
            El archivo de creación de empleados se utiliza para configurar la información básica de los participantes en el sistema a través de un archivo Excel.
            Este debe contener cuatro columnas esenciales: <strong>nombre</strong>, <strong>correo</strong>, <strong>cargo</strong> y <strong>dependencia</strong>.
            Además, tienes la opción de crear dependencias dinámicamente usando <strong>"depend-"</strong> seguido del nombre deseado, todo en una sola palabra.
            <br><br>
            Es fundamental completar todas las casillas y evitar formatos especiales en las celdas para prevenir posibles inconvenientes.
          </p>
        </h2>
        <br />
        <center>
          <img src="@/assets/ejemempleado.png" alt='Imagen de ejemplo para la carga de empleados' width="700px" style="margin-top:2px;" />
        </center>
        <br />

        <footer>
          <button class="button is-link is-medium" style="margin-left:10px;" @click="exportExcelXls">
            <span class="icon">
              <i class="material-icons">cloud_download</i>
            </span>
            <span>Descargar Ejemplo</span>
          </button>
        </footer>
      </section>
    </div>
  </div>
</template>

<script>
const XLSX = require("xlsx");
export default {
  data() {
    return {
      dataToExport: [
        {
          nombre: "nombre apellido ",
          correo: "correoempleado01@correo.com",
          cargo: "auxiliar",
          dependencia: "administrativa",
          'depend-Edad': 22,
          'depend-Genero': "Mujer"
        },
        {
          nombre: "nombre apellido ",
          correo: "correoempleado02@correo.com",
          cargo: "gerente",
          dependencia: "gerencia",
          'depend-Edad': 32,
          'depend-Genero': "Hombre"
        },
        {
          nombre: "nombre apellido ",
          correo: "correoempleado03@correo.com",
          cargo: "developer",
          dependencia: "sistemas",
          'depend-Edad': 41,
          'depend-Genero': "Hombre"
        }
      ],
      ruta: "",
      pass: "",
      id: ""
    };
  },
  props: {
    show: Boolean
  },
  methods: {
    exportExcelXls: function() {
      let data = XLSX.utils.json_to_sheet(this.dataToExport);
      const workbook = XLSX.utils.book_new();
      const filename = "ejemplo-empleados";
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    closeModal() {
      this.$emit("showmodalexampleempl", false);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/modals/Modalexampleempl.vue